import { TitleCasePipe } from '@angular/common';
import { Component, computed, DestroyRef, effect, inject, input, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ReactiveFormsModule } from '@angular/forms';
import { provideIcons } from '@ng-icons/core';
import { lucideCheck, lucideCheckCheck, lucideCircleAlert, lucideSave } from '@ng-icons/lucide';
import { HlmButtonImports } from '@spartan-ng/helm/button';
import { HlmIconImports } from '@spartan-ng/helm/icon';
import { HlmTabsImports } from '@spartan-ng/helm/tabs';
import { HlmTooltipImports } from '@spartan-ng/helm/tooltip';
import { debounceTime, distinctUntilChanged } from 'rxjs';

import { Cartographie } from '../../cartographie/models/cartographie.model';
import { LivrableCaractériséStore } from '../../livrables-caractérisés/store/livrable-caracterisé.store';
import { Module } from '../../référentiel-métier-parcours/models/module.model';
import { InterrelationStore } from '../../référentiel-métier/référentiel-metier-interrelations/store/interrelation.store';
import { Sequence } from '../models/séquence.model';
import { ActivitesComponent } from './activites/activites.component';
import { DetailGeneralComponent } from './detail-general/detail-general.component';
import { DetailLivrablesComponent } from './detail-livrables/detail-livrables.component';
import { DetailObjectifsComponent } from './detail-objectifs/detail-objectifs.component';
import { SéquenceFormService } from './séquence-form.service';
import { Référentiel } from '../../administration/gestion-référentiels/models/référentiel.model';

@Component({
  selector: 'app-sequence-form',
  imports: [
    DetailObjectifsComponent,
    DetailGeneralComponent,
    DetailLivrablesComponent,
    ReactiveFormsModule,
    HlmTabsImports,
    HlmIconImports,
    HlmButtonImports,
    ActivitesComponent,
    HlmTooltipImports,
    TitleCasePipe,
  ],
  templateUrl: './séquence-form.component.html',
  providers: [provideIcons({ lucideCheck, lucideSave, lucideCheckCheck, lucideCircleAlert })],
})
export class SéquenceFormComponent implements OnInit {
  readonly detailFormService = inject(SéquenceFormService);
  readonly #destroy = inject(DestroyRef);
  readonly #interrelationStore = inject(InterrelationStore);
  readonly #livrableCaracteriseStore = inject(LivrableCaractériséStore);

  readonly cartographie = input.required<Cartographie>();
  readonly referentiel = input.required<Référentiel>();
  readonly sequence = input.required<Sequence>();
  readonly module = input.required<Module>();

  readonly traductions = computed(() => this.referentiel().metadonnees.traductions);

  readonly form = this.detailFormService.form;

  constructor() {
    effect(() => {
      this.#interrelationStore.chargerToutes(this.cartographie().id);
      this.#livrableCaracteriseStore.charger(this.module().id);
    });
  }

  ngOnInit(): void {
    this.form.valueChanges
      .pipe(debounceTime(1000), takeUntilDestroyed(this.#destroy), distinctUntilChanged())
      .subscribe(() => this.detailFormService.submit());
  }

  terminerSequence() {
    this.detailFormService.marquerCommeTerminée();
  }
}
